import { render, staticRenderFns } from "./TitleLabel.vue?vue&type=template&id=cb4f36ba&scoped=true&"
import script from "./TitleLabel.vue?vue&type=script&lang=js&"
export * from "./TitleLabel.vue?vue&type=script&lang=js&"
import style0 from "./TitleLabel.vue?vue&type=style&index=0&id=cb4f36ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4f36ba",
  null
  
)

export default component.exports